import React from 'react';
import { connect } from 'react-redux';
import { Button } from 'devextreme-react';
import NavBar from 'devextreme-react/ui/nav-bar';
import { push } from 'connected-react-router';
import { logout } from '../Acceso/Login/actions';
import { resetGlobalState } from '../Global/actions';
import { resetMisDatosState } from '../SucursalVirtual/Trabajador/Perfil/MisDatos/actions';
import { changeTabIndex, openCloseAccountPopOver } from './actions';

import { paths } from '../../config/routes';
import ModalAlert from '../Shared/modalAlert';
import InfoUsuario from './infoUsuario';
// import Notificaciones from "./Notificaciones/view";
import apiConfig from '../../config/api';

import { doGetTokenJwt, doSetNotification } from './Notificaciones/actions';

import Selector from '../PlanMovilidad/Util/selector';

// const signalR = require("@aspnet/signalr");

class Header extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      openModal: false,
      redirect: null,
      typeRedirect: null,
      selectSucursalOpen: false,
      initialCompany: true,
    };

    props.dispatch(doGetTokenJwt(props.userData.Email));
    //this.props.dispatch(doSetNotification(this.props.userData.RUT));
  }

  handlePageTopMargin = () => {
    const page = document.getElementById('content');
    if (page) page.style.marginTop = this.props.subTitle != '' ? '-111px' : '-95px';
    if (
      this.props.location.pathname.includes('siniestros') &&
      !this.props.location.pathname.includes('siniestros-empresa')
    ) {
      page.style.position = 'inherit';
      page.style.marginTop = '-260px';
      page.style.marginLeft = '24px';
      page.style.zIndex = '16';
    }
  };

  componentDidMount = () => {
    this.handlePageTopMargin();
  };

  componentDidUpdate = (prevProps) => {
    this.handlePageTopMargin();

    if (
      prevProps.title === this.props.title &&
      prevProps.userAccessIds &&
      prevProps.tabs &&
      prevProps.tabs.length === 0 &&
      this.props.tabs &&
      this.props.tabs.length === 0
    ) {
      this.props.dispatch(push(paths.root));
    }
    if (this.props.tokenJwt !== prevProps.tokenJwt) {
      // conectar a singlr
      const url = apiConfig.notificationHUB;

      // "Ocp-Apim-Subscription-Key": apiConfig.OcpApimSubscriptionKey
      // const connection = new signalR.HubConnectionBuilder()
      //   .withUrl(`${url}notifications`, { accessTokenFactory: () => this.props.tokenJwt })
      //   .configureLogging(signalR.LogLevel.Information)
      //   .build();

      // connection.start()
      //   .then(() => console.log("Connection started!"))
      //   .catch((err) => console.log("Error while establishing connection :(", err));

      // connection.on("GlobalMessageReceived", () => {
      //   this.props.dispatch(doSetNotification(this.props.userData.RUT));
      // });
      // connection.on("DirectMessageToUserReceived", () => {
      //   this.props.dispatch(doSetNotification(this.props.userData.RUT));
      // });
    }
  };

  handleLogout = () => {
    if (this.props.preventNavigation) {
      this.setState({ openModal: true, redirect: null, typeRedirect: 'logout' });
    } else {
      this.props.dispatch(resetMisDatosState());
      this.props.dispatch(resetGlobalState());
      this.props.dispatch(logout());
    }
  };
  goMyAccount = () => {
    this.props.dispatch(push(paths.perfil));
  };

  checkItem = (e) => {
    if (e.itemIndex !== this.props.tabPosition) {
      if (this.props.preventNavigation) {
        this.setState({
          openModal: true,
          redirect: { contentId: e.itemData.contentId, itemIndex: e.itemIndex },
          typeRedirect: 'tabs',
        });
      } else {
        this.props.dispatch(changeTabIndex(e.itemData.contentId, e.itemIndex));
      }
    }
  };

  closeModal = () => {
    this.setState({
      openModal: false,
      redirect: null,
      typeRedirect: null,
    });
  };

  handleOpenAccountPopover = () => this.props.dispatch(openCloseAccountPopOver(true));
  handleCloseAccountPopover = () => this.props.dispatch(openCloseAccountPopOver(false));

  renderModalAlert() {
    return (
      <React.Fragment>
        <ModalAlert
          open={this.state.openModal}
          title='Alerta'
          message='¿Ha modificado la información de sus datos, desea guardarlos?'
          redirect={this.state.redirect}
          typeRedirect={this.state.typeRedirect}
          closeModalCall={this.closeModal}
        />
      </React.Fragment>
    );
  }

  render() {
    const actualIndex = this.props.menuIsHovering
      ? this.props.menuHoverIndex
      : this.props.menuActiveIndex;
    return (
      <div
        className='col-12 menu-animation-padding'
        style={{
          // height: this.props.location.pathname === "/" ? 76 : this.props.height,
          paddingLeft: this.props.menuWidth,
        }}
      >
        {this.renderModalAlert()}
        {this.props.userData.TempBD && (
          <React.Fragment>
            <h1>ACHS Virtual</h1>
            <Button text='Cerrar sesión' onClick={this.handleLogout} className='button-temporal' />
          </React.Fragment>
        )}

        {!this.props.userData.TempBD && (
          <React.Fragment>
            <div className='header'>
              <div
                className='text-right header-icons col-12'
                style={{ display: 'flex', justifyContent: 'flex-end' }}
              >
                <div id='empresa-centro' className='row col-sm-7' style={{ paddingTop: 15 }}>
                  <Selector />
                </div>

                {/* <div className={`company-notificaction ${this.props.menuActiveIndex === 2 ? "show-div" : "hide-div"}`}>
                  <div className="company-name">{this.props.companyName}</div>
                </div> */}
                {/* <Notificaciones /> */}
                <InfoUsuario
                  isTourOpen={this.props.isTourOpen}
                  isOpen={this.props.isOpenAccountPopOver}
                  handleClose={this.handleCloseAccountPopover}
                  handleOpen={this.handleOpenAccountPopover}
                  logoutCallback={this.handleLogout}
                  myAccountCallback={this.goMyAccount}
                  userData={this.props.userData}
                />
              </div>
              <br />
              <br />
              <div className='title'>
                <h2 style={{ fontSize: 23, marginBottom: 0 }}>{this.props.title || ''} </h2>
                {this.props.subTitle && (
                  <div title={this.props.subTitle} className='header-subTitle'>
                    {this.props.subTitle}
                  </div>
                )}
              </div>
            </div>

            <div
              className='row border-bottom-tabs'
              style={{
                height: this.props.location.pathname === '/' ? 0 : undefined,
                display:
                  this.props.location.pathname.includes('siniestros') &&
                  !this.props.location.pathname.includes('siniestros-empresa')
                    ? 'none'
                    : undefined,
              }}
            >
              <div className='col-10 tab-seccion'>
                {this.props.tabs && (
                  <NavBar
                    dataSource={this.props.tabs}
                    selectionMode='single'
                    onItemClick={this.checkItem}
                    className='header-tabs'
                    noDataText='Sin acceso'
                    selectedIndex={this.props.tabPosition}
                  />
                )}
              </div>
            </div>
          </React.Fragment>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  tabs: state.header.tabs,
  tokenJwt: state.headerNotificaciones.tokenJwt,
  notificactionHeaderList: state.headerNotificaciones.notificactionHeaderList,
  tabPosition: state.header.tabPosition,
  title: state.header.title,
  subTitle: state.header.subTitle,
  isOpenAccountPopOver: state.header.isOpenAccountPopOver,
  isOpenAppStack: state.header.isOpenAppStack,
  userData: state.global.userData,
  listaEmpresas: state.global.listaEmpresas,
  botomBorderColor: state.global.botomBorderColor,
  userAccessIds: state.global.userAccessIds,
  preventNavigation: state.global.preventNavigation,
  location: state.router.location,
  isTourOpen: state.global.isTourOpen,
  companyName: state.global.companyName,
  menuActiveIndex: state.main.menuActiveIndex,
  companyId: state.global.companyId,
  companySucursales: state.global.companySucursales,
});

const mapDispatchToProps = (dispatch) => ({
  dispatch: (action) => {
    dispatch(action);
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(Header);
